import{jsx as r}from"react/jsx-runtime";import t from"styled-components";import i from"../../icons/components/ShowMoreIcon.js";const n=t.div`
  display: flex;
  align-items: center;

  svg {
    font-size: 1.15rem;
    transition: 250ms;
    transform: ${e=>e.isExpanded?"rotate(180deg)":"rotate()"};
  }
`,o=({isExpanded:e})=>r(n,{isExpanded:e,"aria-hidden":"true",role:"presentation",children:r(i,{})});export{o as default};
